import {HttpClient, HttpParams} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";

import {ValApiResultat} from "./ValApiResultat";

//Base pour les services
@Injectable (
{
  providedIn: 'root'
})
export abstract class ValBaseService 
{
  protected readonly httpClient = inject (HttpClient);

  protected abstract get BaseUrl () : string;

  //Exécute une requête GET
  //  Paramètres
  //    url        : Url
  //    parametres : Paramètres
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequeteGet<T> (url: string, parametres?: HttpParams) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let valApiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.BaseUrl}${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.get<ValApiResultat<T>> (urlApi, {params: parametres}).subscribe (
      {
        next: donnees => valApiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (valApiResultat)
      });
    });

    return operation;
  }

  //Exécute une requête POST
  //  Paramètres
  //    url  : Url
  //    body : Body
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequetePost<T> (url: string, body: any) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let apiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.BaseUrl}${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.post<ValApiResultat<T>> (urlApi, body).subscribe (
      {
        next: donnees => apiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (apiResultat)
      });
    });
    
    return operation;
  }

  //Exécute une requête PUT
  //  Paramètres
  //    url  : Url
  //    body : Body
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequetePut<T> (url: string, body: any) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let apiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.BaseUrl}${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.put<ValApiResultat<T>> (urlApi, body).subscribe (
      {
        next: donnees => apiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (apiResultat)
      });
    });
    
    return operation;
  }

  //Exécute une requête DELETE
  //  Paramètres
  //    url  : Url
  //    body : Body
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequeteDelete<T> (url: string, body: any) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let valApiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.BaseUrl}${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.delete<ValApiResultat<T>> (urlApi, { body: body }).subscribe (
      {
        next: donnees => valApiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (valApiResultat)
      });
    });

    return operation;
  }
  
  //Exécute une requête PATCH
  //  Paramètres
  //    url  : Url
  //    body : Body
  //  Retourne
  //    Résultat de la requête
  protected async ExecuterRequetePatch<T> (url: string, body: any) : Promise<ValApiResultat<T>> 
  {
    let operation: Promise<ValApiResultat<T>>;
    let apiResultat: ValApiResultat<T>;
    let urlApi: string;

    urlApi = `${this.BaseUrl}${url}`;

    operation = new Promise<ValApiResultat<T>> ((retourReussi, retourErreur) =>
    {
      this.httpClient.patch<ValApiResultat<T>> (urlApi, body).subscribe (
      {
        next: donnees => apiResultat = donnees,
        error: erreur => retourErreur (erreur),
        complete: () => retourReussi (apiResultat)
      });
    });
    
    return operation;
  }
}
